import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router';

import { ScrollArea } from '~/components/shadcn/scroll-area.tsx';
import { SettingsNavbar } from '~/components/user/settings-navbar.tsx';
import { requireAuthenticatedBeforeLoad } from '~/routing/require-authenticated-before-load.ts';
import { getUserSettingsPageDataQueryOptions } from '~/server/user/user-settings-page-data-query.ts';
import { cn } from '~/utils/cn.ts';

export const Route = createFileRoute('/user')({
	beforeLoad: requireAuthenticatedBeforeLoad,
	component: UserSettingsLayout,
	loader: ({ context }) => context.queryClient.ensureQueryData(getUserSettingsPageDataQueryOptions()),
});

function UserSettingsLayout() {
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});
	const settingsPath = pathname.split('/').at(2);
	const headingText = (settingsPath ?? '').charAt(0).toUpperCase() + (settingsPath ?? '').slice(1);

	return (
		<div className="flex h-full flex-row">
			<SettingsNavbar />
			<div className={cn('w-full pt-4 pr-6 pl-6 sm:pr-12 md:pr-32', 'max-h-full bg-muted')}>
				<ScrollArea
					className="flex h-full"
					classNames={{
						thumb: 'bg-card',
						viewport: 'h-full',
					}}
				>
					<div className="flex h-full w-full flex-col pr-8">
						<div className="w-full">
							{settingsPath ? (
								<h1 className="whitespace-nowrap font-semibold text-lg text-muted-foreground" title={settingsPath}>
									{headingText}
								</h1>
							) : null}
						</div>
						<div className="flex h-full">
							<Outlet />
						</div>
					</div>
				</ScrollArea>
			</div>
		</div>
	);
}
